import styled from '@emotion/styled'
import { isMobile } from '@const/device'

const DesktopFooter = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 15px;
`
const MobileFooter = styled(DesktopFooter)`
  flex-direction: column;
`
export const Footer = isMobile ? MobileFooter : DesktopFooter
